import { commonFetch } from "./fetch";

// 安全用气列表
// 获取标签
export function getSafeyGasTags(): Promise<string[]> {
  return commonFetch(
    "/crm-dms/v1/safety/gas/tag/list",
    true,
  );
}

// 获取关键字
export function getSafeyGasWords(): Promise<string[]> {
  return commonFetch(
    "/crm-dms/v1/safety/gas/keyword/list",
    true,
  );
}

// 获取列表
export function getSafeyGasList(
  data: SafeyGasListParams
): Promise<SafeyGasListData> {
  return commonFetch(
    "/crm-dms/v1/safety/gas/shop/pageList",
    true,
    data,
  );
}

// 获取安全用气详情
export function getSafeyGasDetail(
  id: string
): Promise<SafeyGasDetailData> {
  return commonFetch(
    "/crm-dms/v1/safety/gas/getById",
    true,
    { id },
  );
}

const safetyGasApi = {
  getSafeyGasTags,
  getSafeyGasWords,
  getSafeyGasList,
  getSafeyGasDetail,
}

export default safetyGasApi;
